import { v4 as generateUuid } from 'uuid';

import { startOfCurrentYear } from '../../helpers/date';
import { EducationLevel, EducationSubLevel, LearningPath } from '../EducationLevels';

export interface SchoolExperienceResource {
    id: string;
    educationLevel: string;
    educationSubLevel?: string;
    learningPath?: string;
    degree: string;
    school: string;
    startDate: Date;
    endDate: Date;
}

export interface SchoolExperienceRequest {
    id: string;
    educationLevel: string;
    educationSubLevel?: string;
    learningPath?: string;
    degree: string;
    school: string;
    startDate: string;
    endDate: string;
}

export interface SchoolExperience {
    id: string;
    educationLevel: EducationLevel;
    educationSubLevel?: EducationSubLevel;
    learningPath?: LearningPath;
    fieldOfStudy: string;
    fieldOfStudyId: string;
    school: string;
    startDate: Date;
    endDate: Date;
}

export type SchoolExperienceFormData = SchoolExperience;

export const defaultSchoolExperience = (): SchoolExperience => ({
    id: generateUuid(),
    educationLevel: EducationLevel.primaryEducation,
    fieldOfStudy: '',
    fieldOfStudyId: '',
    school: '',
    startDate: startOfCurrentYear,
    endDate: startOfCurrentYear,
});
